/* My Orders */

jQuery(document).ready(function($) {

	$(".c-droptable--line tr td:first-child").on("click", function() {
		$(this).closest(".c-droptable").toggleClass("active");
	});

	$(".c-droptable--actions__drop").on("click", function() {
		$(this).closest(".c-droptable").toggleClass("active");
	});

});
